"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideCartAnalyticsService = exports.SIDE_CART_VWO_PLACEMENT_KEY = void 0;
const tag_book_sellout_1 = require("@grupoboticario/tag-book-sellout");
const types_1 = require("../../types");
const VWOAnalyticsService_1 = require("./VWOAnalyticsService");
exports.SIDE_CART_VWO_PLACEMENT_KEY = 'sideCart';
class BeginCheckoutTagError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BeginCheckoutTagError';
    }
}
class SideCartAnalyticsService {
    static beginCheckout(products) {
        let enhancedProducts = products;
        try {
            enhancedProducts = (products !== null && products !== void 0 ? products : []).map(SideCartAnalyticsService.enhanceWithLowStockGaDimensions);
        }
        catch (err) {
            window.NREUM.noticeError(new BeginCheckoutTagError(`Failed to tag begin checkout: ${err}. Products: ${enhancedProducts}`), {
                origin: 'MLD/SideCart',
                brand: process.env.REACT_APP_CURRENT_BRAND,
                params: {
                    enhancedProducts,
                },
            });
        }
        finally {
            (0, tag_book_sellout_1.ecommerceEvent)({
                eventName: 'begin_checkout',
                products: enhancedProducts,
            });
        }
    }
    static clickViewProduct() {
        VWOAnalyticsService_1.VWOAnalyticsService.dispatchVWOEvent(types_1.VWOEvents.CLICK_ON_VIEW_PRODUCT, {
            placement: exports.SIDE_CART_VWO_PLACEMENT_KEY,
        });
    }
    static clickSendOrder() {
        VWOAnalyticsService_1.VWOAnalyticsService.dispatchVWOEvent(types_1.VWOEvents.USER_CLICKED_ON_SEND_ORDER, {
            placement: exports.SIDE_CART_VWO_PLACEMENT_KEY,
        });
    }
    static clickOnChooseMore() {
        VWOAnalyticsService_1.VWOAnalyticsService.dispatchVWOEvent(types_1.VWOEvents.USER_CLICKED_ON_CHOOSE_MORE, {
            placement: exports.SIDE_CART_VWO_PLACEMENT_KEY,
        });
    }
    static clickIncrementItem() {
        VWOAnalyticsService_1.VWOAnalyticsService.dispatchVWOEvent(types_1.VWOEvents.CLICK_ON_CHANGE_PRODUCT_QUANTITY, {
            actiontype: 'increment',
            placement: exports.SIDE_CART_VWO_PLACEMENT_KEY,
        });
    }
    static clickDecrementItem() {
        VWOAnalyticsService_1.VWOAnalyticsService.dispatchVWOEvent(types_1.VWOEvents.CLICK_ON_CHANGE_PRODUCT_QUANTITY, {
            actiontype: 'decrement',
            placement: exports.SIDE_CART_VWO_PLACEMENT_KEY,
        });
    }
    static clickRemoveItem() {
        VWOAnalyticsService_1.VWOAnalyticsService.dispatchVWOEvent(types_1.VWOEvents.CLICK_ON_REMOVE_PRODUCT_FROM_CART);
    }
    static enhanceWithLowStockGaDimensions(p) {
        var _a, _b;
        const isLowStock = (_b = (_a = p === null || p === void 0 ? void 0 : p.tags) === null || _a === void 0 ? void 0 : _a.some((tag) => /^poucas unidades$/i.test(tag))) !== null && _b !== void 0 ? _b : false;
        return Object.assign(Object.assign({}, p), { category5: isLowStock ? 'poucas-unidades' : undefined, status: isLowStock ? 'poucas-unidades' : p.status });
    }
}
exports.SideCartAnalyticsService = SideCartAnalyticsService;
